const ADD_EXPEDITION_DAY = "ADD_EXPEDITION_DAY";
const MANAGE_NOTIFICATION = "MANAGE_NOTIFICATION";
const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
const ADD_NOTIFICATION = "ADD_NOTIFICATION";
const EDIT_EXPEDITION = "EDIT_EXPEDITION";
const ADD_EXPEDITION = "ADD_EXPEDITION";
const SET_SELECTED_EXPEDITION = "SET_SELECTED_EXPEDITION";
const ADD_ENDLOAD_PICTURE = "ADD_ENDLOAD_PICTURE";
const ADD_AUTOCONTROL_PICTURE = "ADD_AUTOCONTROL_PICTURE";
const REMOVE_AUTOCONTROL_PICTURE = "REMOVE_AUTOCONTROL_PICTURE";
const REMOVE_ENDLOAD_PICTURE = "REMOVE_ENDLOAD_PICTURE";
const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
const CLEAN_EXPEDITION = "CLEAN_EXPEDITION";
const SET_EXPEDITION_AUTOCONTROL = "SET_EXPEDITION_AUTOCONTROL";
const SET_SELECTED_NOTIFICATION = "SET_SELECTED_NOTIFICATION";
const EDIT_SELECTED_EFFECTIVE_ARRIVAL = "EDIT_SELECTED_EFFECTIVE_ARRIVAL";
const DELETE_EXPEDITION = "DELETE_EXPEDITION";
const SET_EXPEDITION_START_SLOT = "SET_EXPEDITION_START_SLOT";
const SET_EXPEDITION_END_SLOT = "SET_EXPEDITION_END_SLOT";

export {
    ADD_EXPEDITION_DAY,
    MANAGE_NOTIFICATION,
    ADD_NOTIFICATIONS,
    ADD_NOTIFICATION,
    EDIT_EXPEDITION,
    ADD_EXPEDITION,
    SET_SELECTED_EXPEDITION,
    ADD_ENDLOAD_PICTURE,
    ADD_AUTOCONTROL_PICTURE,
    REMOVE_AUTOCONTROL_PICTURE,
    REMOVE_ENDLOAD_PICTURE,
    CLEAN_EXPEDITION,
    SET_EXPEDITION_AUTOCONTROL,
    SET_SELECTED_NOTIFICATION,
    EDIT_SELECTED_EFFECTIVE_ARRIVAL,
    REMOVE_NOTIFICATION,
    DELETE_EXPEDITION,
    SET_EXPEDITION_START_SLOT,
    SET_EXPEDITION_END_SLOT,
};
